var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { Router, Switch } from 'react-router-dom';
import { Provider } from 'mobx-react';
import cxs from 'cxs/component';
import { opacity } from 'helpers/Colors';
import Store from './Store';
import Theme from './Theme';
import history from 'helpers/History';
import Main from 'scenes/Main';
import Login from 'scenes/Login';
import Recovery from 'scenes/Recovery';
import { Route, UIMessage } from 'components';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
/*import 'flag-icon-css/css/flag-icon.min.css';*/
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css';
import { api } from './helpers/Api';
import { Client } from '@hapi/nes/lib/client';
import { Cart } from './modules/CartTicketResult';
import QueryParams from './components/QueryParams';
import CheckUserMark from './components/CheckUserMark';
export var store = new Store();
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSuscribirWS = function () {
            var ws = new WebSocket('ws://api.crea-ticket.com:8085/api_dev/v2');
            ws.onopen = function () {
                ws.send(JSON.stringify({
                    auth: {
                        headers: {
                            authorization: api.defaults.headers.common.Authorization,
                            'x-client': api.defaults.headers.common['X-Client'],
                            'x-provider': 'creaticket',
                        }
                    },
                    command: 'subscribe',
                    identifier: { channel: '/nes/id' }
                }));
            };
            ws.onmessage = function (msg) {
                console.log('ws - msg: ', msg);
            };
        };
        _this.handleSubscribe = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_1, nesToken, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.client = new Client('wss://api.crea-ticket.com/api_dev/v2');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.client.connect({
                                auth: {
                                    headers: {
                                        authorization: api.defaults.headers.common.Authorization,
                                        'x-client': api.defaults.headers.common['X-Client'],
                                        'x-provider': 'creaticket',
                                    }
                                }
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log('error: ', e_1.message);
                        return [3 /*break*/, 4];
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        nesToken = store.users.user.nesToken;
                        return [4 /*yield*/, this.client.subscribe("/message-".concat(nesToken), function (update, flags) {
                                console.log('update', update);
                                console.log('flags', flags);
                                store.UI.newWarning('msg: ' + update.result);
                                var audio = new Audio('/assets/sounds/caja.mp3');
                                audio.play();
                            })];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        e_2 = _a.sent();
                        console.log('error: ', e_2);
                        return [3 /*break*/, 7];
                    case 7:
                        this.client.onUpdate = function (update) {
                            console.log('onUpdate: ', update);
                        };
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleUnSubscribe = function () {
            _this.client.unsubscribe("/message-".concat('QkymSSjsXwqxMJxyLwIxZkUTuRnRXLVmvUZOmJHK'), function (message, flags) {
                console.log('message: ', message);
                console.log('flags: ', flags);
            });
        };
        return _this;
    }
    App.prototype.componentDidMount = function () {
        /*
            this.client.connect({
              auth: {
                headers: {
                  authorization: 'Bearer ae317c402a5e11ac90567020c954728f98d02bf5273fb8fbcc6e7ff5cd693e61',
                  'x-client': 'Entornotest5',
                  'x-provider': 'creaticket'
                }
              }})
              .then(value => {
                console.log('value: ', value)
              })
              .catch(reason => {
                console.log('connect - error: ', reason)
              })
        
            this.client.subscribe('/Entornotest5/tickets/id', (update, flags) => {
              console.log('subscribe - update: ', update)
              console.log('subscribe - flags: ', flags)
            })*/
        try {
            // this.handleSubscribe()
        }
        catch (error) {
        }
    };
    App.prototype.componentWillUnmount = function () {
        if (this.client)
            this.client.disconnect();
    };
    /*handleSubscribe = () => {
      // this.client = new Nes.Client('ws://api.crea-ticket.com:8085/api_dev/v2/nes/5');
      this.client = new Nes.Client('ws://api.crea-ticket.com:8085');
  
      this.client.connect({
        auth: {
          headers: {
            authorization: api.defaults.headers.common.Authorization,
            'x-client':  api.defaults.headers.common['X-Client'],
            'x-provider':  'creaticket',
          }
        }
      }, (error) => {
        if (error) {
          console.log('error: ', error)
          return store.UI.newError('error: ' + error.message)
        }
  
        const handlerSuscription = function(err, update) {
          if (err) {
            console.log('handlerSuscription - err: ', err)
            return store.UI.newError(err.message)
          }
          console.log('handlerSuscription - update: ', update)
          store.UI.newWarning(update)
        }
  
        this.client.subscribe('/nes/id', handlerSuscription, function(err) {
          if (err) {
            console.log('subscribe - err: ', err)
            store.UI.newError(err.message)
          }
        })
  
        console.log('subscriptions: ', this.client.subscriptions())
  
        this.client.onUpdate = function(update) {
          console.log('onUpdate - update: ', update)
        }
  
      })
  
    }*/
    /*handleUnSubscribe = () => {
      if (!this.client) return
      this.client.unsubscribe('/nes/id', (message, flags) => {
        console.log('message: ', message)
        console.log('flags: ', flags)
      }, err => {
        if (err) console.log('unsubscribe - error: ', err)
      })
    }*/
    App.prototype.render = function () {
        return (React.createElement(Router, { history: history },
            React.createElement(Provider, { store: store },
                React.createElement(Wrapper, null,
                    React.createElement(UIMessage, null),
                    React.createElement(Switch, null,
                        React.createElement(Route, { exact: true, path: "/checkuser", component: QueryParams(CheckUserMark) }),
                        React.createElement(Route, { exact: true, path: "/login", component: QueryParams(Login) }),
                        React.createElement(Route, { exact: true, path: "/cart/:client/:carttoken", component: Cart }),
                        React.createElement(Route, { exact: true, path: "/recovery", component: QueryParams(Recovery) }),
                        React.createElement(Route, { path: "/", component: QueryParams(Main), auth: true }),
                        React.createElement(Route, { render: function () { return React.createElement("p", null, "404"); } }))))));
    };
    return App;
}(Component));
export default App;
var Wrapper = cxs('div')({
    display: 'flex',
    height: '100%',
    fontSize: Theme.fontSize.regular,
    fontFamily: Theme.fontFamily,
    fontWeight: Theme.fontWeight,
    lineHeight: Theme.lineHeight,
    color: Theme.color.secondary,
    // textTransform: 'capitalize',
    '-webkit-tap-highlight-color': opacity(0.25, Theme.color.primary)
});



//////////////////
// WEBPACK FOOTER
// ./src/App.tsx
// module id = 65
// module chunks = 0